import { useTranslation } from 'react-i18next'
import type { QuickSuggestionProps } from '@brochure/shared'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-col gap-px">
      {suggestions.map((suggestion, idx) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className={[
            'group w-full text-left',
            'flex items-center justify-between gap-4',
            'px-4 py-3',
            'bg-[var(--color-surface)] hover:bg-[var(--color-fg)]',
            'text-[var(--color-fg)] hover:text-[var(--color-bg)]',
            'border border-[var(--color-border)] hover:border-[var(--color-fg)]',
            'transition-[background,color,border,transform] duration-[var(--duration-fast)]',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            idx > 0 ? '-mt-px' : '',
          ].join(' ')}
          style={{
            borderRadius: 'var(--radius-sm)',
            fontFamily: 'var(--font-body)',
          }}
        >
          <span className="flex flex-col items-start min-w-0">
            <span
              aria-hidden="true"
              className="block mb-1.5"
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: '0.625rem',
                letterSpacing: '0.18em',
                textTransform: 'uppercase',
                color: 'var(--color-muted)',
                fontWeight: 500,
              }}
            >
              {String(idx + 1).padStart(2, '0')}
            </span>
            <span
              className="text-[0.9375rem] leading-tight"
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 500,
                letterSpacing: 'var(--tracking-display)',
              }}
            >
              {t(suggestion.labelKey)}
            </span>
          </span>
          <span
            aria-hidden="true"
            className="flex-shrink-0 transition-transform duration-[var(--duration-fast)] group-hover:translate-x-0.5"
            style={{ color: 'var(--color-highlight)' }}
          >
            <svg width="18" height="10" viewBox="0 0 18 10" fill="none" aria-hidden="true">
              <path
                d="M0 5 H16 M12 1 L16 5 L12 9"
                stroke="currentColor"
                strokeWidth="1"
                fill="none"
              />
            </svg>
          </span>
        </button>
      ))}
    </div>
  )
}
